import { Directive } from "@angular/core";

/**
 * Wrapper for search action buttons in a mat-card with consistent styling.
 * Extends search form styling with proper button alignment.
 *
 * @example
 * <mat-card>
 *   <mgd-card-search-actions>
 *     <button mat-raised-button>Search</button>
 *     <button mat-button>Clear</button>
 *   </mgd-card-search-actions>
 * </mat-card>
 */
@Directive({
    selector: "mgd-card-search-actions",
    host: {
        class: "mgd-card-search-actions"
    }
})
export class CardSearchActionsDirective {}
